export const EMAIL_UPDATE = 'EMAIL_UPDATE';
export const EMAIL_UPDATE_PENDING = `${EMAIL_UPDATE}_PENDING`;
export const EMAIL_UPDATE_FAILED = `${EMAIL_UPDATE}_FAILED`;
export const EMAIL_UPDATE_SUCCESS = `${EMAIL_UPDATE}_SUCCESS`;
